import React from 'react';
import styled from 'styled-components';

const CardCoverActionBorder = styled.div`
  background-color: ${props => props.theme.colorPrimary};
  height: 10px;
  border-radius: ${props => props.theme.borderRadius}px
    ${props => props.theme.borderRadius}px 0 0;
`;

export interface CardCoverActionProps {}

export function CardCoverAction(props: CardCoverActionProps) {
  return <CardCoverActionBorder />;
}
